import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { func, object } from 'prop-types';
import InlineError from '../Forms/InlineError';

const propTypes = {
  submit: func.isRequired,
  change: func.isRequired,
  data: object.isRequired,
  errors: object,
};

const defaultProps = {
  submit() {},
  change() {},
  data: {},
  errors: {},
};

const AffiliatePasswordRecoveryConfirm = ({ submit, change, data, errors }) => {
  const [isPasswordVisible, setVisibility] = useState(false);

  const toggleVisibility = () => setVisibility(!isPasswordVisible);

  const getPasswordIcon = () =>
    isPasswordVisible ? (
      <span className="btn-eye-off-outline" />
    ) : (
      <span className="btn-eye-outline" />
    );

  return (
    <form onSubmit={submit} autoComplete="off">
      <div className={errors.new_password ? 'form-group has-error' : 'form-group'}>
        <label htmlFor="new_password" className="label">
          <FormattedMessage id="password.recovery.field.new_pass" defaultMessage="New Password" />
        </label>
        <div className="input-with-toggle">
          <span className="input-with-toggle-title">Новый пароль</span>
          <input
            id="new_password"
            className="form-control"
            type={isPasswordVisible ? 'text' : 'password'}
            name="new_password"
            value={data.new_password}
            onChange={change}
            tabIndex="1"
            autoFocus
            required
          />
          <button type="button" onClick={toggleVisibility}>
            {getPasswordIcon()}
          </button>
        </div>
        {errors.new_password && <InlineError text={errors.new_password} />}
      </div>

      <div className={errors.reply_password ? 'form-group has-error' : 'form-group'}>
        <label htmlFor="reply_password" className="label">
          <FormattedMessage
            id="password.recovery.field.reply_pass"
            defaultMessage="Confirm Password"
          />
        </label>
        <div className="input-with-toggle">
          <span className="input-with-toggle-title">Повторите пароль</span>
          <input
            id="reply_password"
            className="form-control"
            type={isPasswordVisible ? 'text' : 'password'}
            name="reply_password"
            value={data.reply_password}
            onChange={change}
            tabIndex="1"
            required
          />
          <button type="button" onClick={toggleVisibility}>
            {getPasswordIcon()}
          </button>
        </div>
        {errors.reply_password && <InlineError text={errors.reply_password} />}
      </div>

      <div className="form-controls">
        <button type="submit" className="btn btn-primary btn-block no-margin" tabIndex="3">
          <FormattedMessage id="password.recovery.field.send" defaultMessage="Send" />
        </button>
      </div>
    </form>
  );
};

AffiliatePasswordRecoveryConfirm.propTypes = propTypes;
AffiliatePasswordRecoveryConfirm.defaultProps = defaultProps;

export default AffiliatePasswordRecoveryConfirm;
